var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M114 156v-36a6.003 6.003 0 0 0-1.757-4.243A6.003 6.003 0 0 0 108 114H84a6 6 0 0 0-6 6v36a6 6 0 0 1-6 6H36a6 6 0 0 1-6-6V86.625a6.224 6.224 0 0 1 1.95-4.425l60-54.525a6 6 0 0 1 8.1 0l60 54.525a6.223 6.223 0 0 1 1.95 4.425V156a6.002 6.002 0 0 1-6 6h-36a6.002 6.002 0 0 1-6-6Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M114 156v-36a6.003 6.003 0 0 0-1.757-4.243A6.003 6.003 0 0 0 108 114H84a6 6 0 0 0-6 6v36a6 6 0 0 1-6 6H36a6 6 0 0 1-6-6V86.625a6.224 6.224 0 0 1 1.95-4.425l60-54.525a6 6 0 0 1 8.1 0l60 54.525a6.223 6.223 0 0 1 1.95 4.425V156a6.002 6.002 0 0 1-6 6h-36a6.002 6.002 0 0 1-6-6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.9ece8865958613bdb548555bb402e73a.svg";
export { ForwardRef as ReactComponent };